import { type RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const SignInPage = lazy(() => import('../pages/signin/page'));
const ActionsBonusesPage = lazy(() => import('../pages/actions-bonuses/page'));
const ApplicationRequestsPage = lazy(
  () => import('../pages/application-requests/page'),
);
const ObschieNastroykiPage = lazy(
  () => import('../pages/obschie-nastroyki/page'),
);
const PartnersListPage = lazy(() => import('../pages/partners-list/page'));
const PromotionCreateEditPage = lazy(
  () => import('../pages/promotion-create-edit/page'),
);
const RecommendationsListPage = lazy(
  () => import('../pages/recommendations-list/page'),
);
const ReportsPage = lazy(() => import('../pages/reports/page'));
const ReportsV1Page = lazy(() => import('../pages/reports-v1/page'));
const SistemnieUvedomleniyaPage = lazy(
  () => import('../pages/sistemnie-uvedomleniya/page'),
);
const UsersListPage = lazy(() => import('../pages/users-list/page'));
const ClientsListPage = lazy(() => import('../pages/clients-list/page'));
const WithdrawalRequestsPage = lazy(
  () => import('../pages/withdrawal-requests/page'),
);
const LevelsPage = lazy(() => import('../pages/levels/page'));
const AllowedDomainsPage = lazy(() => import('../pages/allowed-domains/page'));
const ContentPagesPage = lazy(() => import('../pages/content-pages/page'));
const SuccessStoriesPage = lazy(() => import('../pages/success-stories/page'));
const PartnerApplicationsPage = lazy(
  () => import('../pages/partner-applications/page'),
);
const ProfileModerationPage = lazy(
  () => import('../pages/profile-moderation/page'),
);
const SupportChatPage = lazy(() => import('../pages/support-chat/page'));
const ReviewsListPage = lazy(() => import('../pages/reviews-list/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/signin',
    element: <SignInPage />,
  },
  {
    path: '/actions',
    element: (
      <ProtectedRoute>
        <ActionsBonusesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/application-requests',
    element: (
      <ProtectedRoute>
        <ApplicationRequestsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/obschie-nastroyki',
    element: (
      <ProtectedRoute>
        <ObschieNastroykiPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/partners-list',
    element: (
      <ProtectedRoute>
        <PartnersListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/actions/create',
    element: (
      <ProtectedRoute>
        <PromotionCreateEditPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/actions/:id/edit',
    element: (
      <ProtectedRoute>
        <PromotionCreateEditPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/recommendations-list',
    element: (
      <ProtectedRoute>
        <RecommendationsListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/reports',
    element: (
      <ProtectedRoute>
        <ReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/reports-v1',
    element: (
      <ProtectedRoute>
        <ReportsV1Page />
      </ProtectedRoute>
    ),
  },
  {
    path: '/sistemnie-uvedomleniya',
    element: (
      <ProtectedRoute>
        <SistemnieUvedomleniyaPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/users-list',
    element: (
      <ProtectedRoute>
        <UsersListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/clients-list',
    element: (
      <ProtectedRoute>
        <ClientsListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/withdrawal-requests',
    element: (
      <ProtectedRoute>
        <WithdrawalRequestsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/levels',
    element: (
      <ProtectedRoute>
        <LevelsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/allowed-domains',
    element: (
      <ProtectedRoute>
        <AllowedDomainsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/content-pages',
    element: (
      <ProtectedRoute>
        <ContentPagesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/success-stories',
    element: (
      <ProtectedRoute>
        <SuccessStoriesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/partner-applications',
    element: (
      <ProtectedRoute>
        <PartnerApplicationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/profile-moderation',
    element: (
      <ProtectedRoute>
        <ProfileModerationPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/support-chat',
    element: (
      <ProtectedRoute>
        <SupportChatPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/reviews-list',
    element: (
      <ProtectedRoute>
        <ReviewsListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
